import * as React from 'react';
import styled from 'styled-components';

import { InputGroup } from 'components/bootstrap';
import type LookupTableParameter from 'views/logic/parameters/LookupTableParameter';

import type { ParameterInputComponentProps } from '../ParameterTypes';

const TableInfo = styled(InputGroup.Addon)`
  width: auto;
  text-align: left;
  cursor: not-allowed;
`;

type Props = ParameterInputComponentProps<LookupTableParameter>;

const LookupTableParameterPreview = ({ parameter: { key, lookupTable } }: Props) => (
  <TableInfo>
    Lookup Table: {lookupTable} &ndash; {key}
  </TableInfo>
);

export default LookupTableParameterPreview;
